<template>
    <section>
        <b-collapse class="card">
            <div slot="trigger" slot-scope="props" class="card-header">
                <p class="card-header-title">
                    Book Details
                </p>
                <a class="card-header-icon">
                    <b-icon
                        :icon="props.open ? 'menu-up' : 'menu-down'">
                    </b-icon>
                </a>
            </div>
            <div class="card-content">
                <div class="content">
                    <p><strong>Title</strong>: {{ Title }}</p>
                    <p><strong>Description</strong>: {{ Description }}</p>
                    <p><strong>Author</strong>: {{ Author }}</p>
                    <p><strong>Year</strong>: {{ Year }}</p>
                </div>
            </div>
        </b-collapse>
    </section>
</template>

<script>
export default {
    name: 'BookDetails',
    data() {
        return {
            Title: '1984',
            Description: 'This is some description',
            Year: '1984',
            Author: 'George Orwell',
        }
    }
}
</script>

<style scoped>
.card-header-title, .card-header-icon {
    color: #ffffff !important;
}
.card-header {
    background-color: #363636 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/features/CreateBook/BookDetails.vue